import _ from 'lodash'

class DetailResultController {
  constructor(recordId, DetailResultService, UpgradeTeaser, $analytics, config) {
    this.$analytics      = $analytics
    this.record          = DetailResultService.queryById(recordId)
    this.UpgradeTeaser   = UpgradeTeaser
    this.purchaseOptions = ['preview', 'purchase']
    this.config          = config
  }

  openSpeedbump() {
    const price = this.record.numberOfPages || "1 per page"
    const urls  = _.reduce(this.purchaseOptions, this._parseSourceUrl.bind(this), {})
    const modalConfig = {
      template: 'buy-document-speedbump.partial.html',
      urls: urls,
      price: price
    }

    this.UpgradeTeaser.setConfig(modalConfig)
    this.UpgradeTeaser.openModal()
    
    this.$analytics.eventTrack('TXFile Modal Appearance', {
      state  : this.record.state,
      county : this.record.county,
      docType: this.record.typeOfDocument
    })
  }

  _parseSourceUrl(accumulator, value) {
    const linkWithPurchaseOption = this.record.sourceUrl.replace('{0}', value)
    accumulator[value] = linkWithPurchaseOption.replace('{1}', this.config.productName)
    return accumulator
  }
}

DetailResultController.$inject = [ 'recordId', 'DetailResultService', 'UpgradeTeaser', '$analytics', 'config']

export default DetailResultController
